import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE_WARRANTIES_LIST = {
  'job': {},
  'part': {},
  'jobsList': [],
  'partsList': [],
  'subcontractList': [],
  'loading': false,
  'lodingParts': false,
  'loadingJobs': false,
};

export const warrantiesCategories = (state, action) => {
  return createReducer(INITIAL_STATE_WARRANTIES_LIST, {
    [ActionTypes.FETCHING_TWC_WARRANTIES_JOB]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTIES_JOB]: (state, action) => ({
      ...state,
      'loading': false,
      'job': action.response.data,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTIES_JOB_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'job': {},
    }),
    [ActionTypes.FETCHING_TWC_WARRANTIES_SUBCONTRACT_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTIES_SUBCONTRACT_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'subcontractList': action.response.data,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTIES_SUBCONTRACT_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'subcontractList': [],
    }),
    [ActionTypes.FETCHING_TWC_WARRANTIES_PART]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTIES_PART]: (state, action) => ({
      ...state,
      'loading': false,
      'part': action.response.data,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTIES_PART_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'part': {},
    }),
    [ActionTypes.CLEAR_SEARCH_PART_WARRANTY]: (state, action) => ({
      ...state,
      'loadingParts': false,
      'loadingJobs': false,
      'loading': false,
      'partsList': [],
      'jobsList': [],
      'part': {},
    }),
    [ActionTypes.FETCHING_TWC_WARRANTIES_PARTS_BY_SEARCH]: (state, action) => ({
      ...state,
      'loadingParts': true,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTIES_PARTS_BY_SEARCH]: (state, action) => ({
      ...state,
      'loadingParts': false,
      'partsList': action.response.data,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTIES_PARTS_BY_SEARCH_FAILED]: (
      state,
      action
    ) => ({
      ...state,
      'loadingParts': false,
      'partsList': [],
    }),
    [ActionTypes.FETCHING_TWC_WARRANTIES_JOBS_LIST_BY_SEARCH]: (
      state,
      action
    ) => ({
      ...state,
      'loadingJobs': true,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTIES_JOBS_LIST_BY_SEARCH]: (
      state,
      action
    ) => ({
      ...state,
      'loadingJobs': false,
      'jobsList': action.response.data,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTIES_JOBS_LIST_BY_SEARCH_FAILED]: (
      state,
      action
    ) => ({
      ...state,
      'loadingJobs': false,
      'jobsList': [],
    }),
  })(state, action);
};

